import React, { useState } from "react";
import 
{ Link } from "react-router-dom";
import vits_logo from "../../assets/vitsnamelogo.png"
import "./navbar.css"
import { useEffect, useRef } from 'react';
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(ScrollTrigger);
function Navbar() {
  //change nav color 
  const [color , setColor]=useState(false)
  const changeColor=()=>{
    if(window.scrollY >=30){
      setColor(true)

    }
    else{
      setColor(false)
    }
  }
  window.addEventListener('scroll',changeColor)
  //gsap
  useGSAP(()=>{
    gsap.from(".logo",{
      y:-100,
      duration:.4,

    })
    gsap.from("nav ul li",{
      y:-130,
      duration:.8,
      // stagger:.2
    })
    gsap.from(".log_in",{
      y:-100,duration:.8
    })
  })
  return (
    <div className={color ? "navbar_container navbar_bg ":"navbar_container"} >
      <div className="navbar">
        <div className="logo">
          <img src={vits_logo} />
        </div>

        {/* navlink */}
        <nav>
          <ul>
            <li>
             
              <Link to="/">Home
              </Link>
            </li>
            <li>
             
              <Link to="/department">Department  
              {/* <i className="fa fa-angle-down"></i> */}
              </Link>
            </li>
          
            {/* <li>
             
              <Link to="#">Courses 
              <i className="fa fa-angle-down"></i>
              </Link>
            </li> */}

            <li>
             
              <Link to="/contact">Contact us
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
